import { type ItemOf } from '@shared/board'
import { clsx } from 'clsx'
import { DRAG_HANDLE, NO_DRAG } from '../classes'
import { Link2 } from 'lucide-react'
import { useState } from 'react'

export function LinkView({ item, selected }: { item: ItemOf<'link'>; selected: boolean }) {
  const { url, title, description, siteName, image, favicon } = item.data
  const host = (() => {
    try {
      return new URL(url).host.replace(/^www\./, '')
    } catch {
      return url
    }
  })()
  const [iconOk, setIconOk] = useState(true)
  const [imageOk, setImageOk] = useState(true)
  return (
    <div
      className={clsx(
        'moot-node ' +
          DRAG_HANDLE +
          ' relative cursor-grab overflow-hidden rounded-md border bg-surface shadow-sm active:cursor-grabbing',
        selected ? 'border-(--focus)' : 'border-line',
      )}
      style={{ width: item.w }}
    >
      {image && imageOk && (
        <img
          src={image}
          alt=""
          draggable={false}
          referrerPolicy="no-referrer"
          onError={() => {
            setImageOk(false)
          }}
          className="block aspect-[1.91/1] w-full border-b border-line object-cover"
        />
      )}
      <div className="px-3 py-2.5">
        <div className="flex items-center gap-1.5 text-[11.5px] text-muted">
          {favicon && iconOk ? (
            <img
              src={favicon}
              alt=""
              referrerPolicy="no-referrer"
              onError={() => {
                setIconOk(false)
              }}
              className="size-3.5 rounded-[3px]"
            />
          ) : (
            <Link2 size={13} />
          )}
          <span className="truncate">{siteName ?? host}</span>
        </div>
        <a
          href={url}
          target="_blank"
          rel="noreferrer noopener"
          className={
            NO_DRAG +
            ' mt-1 line-clamp-2 block text-[13.5px] leading-snug font-medium text-ink hover:underline'
          }
        >
          {title ?? url}
        </a>
        {description && (
          <p className="mt-1 line-clamp-2 text-[12.5px] leading-snug text-muted">{description}</p>
        )}
      </div>
    </div>
  )
}
